import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleUnavailabilityRemoval(
  state: State,
  unavailability: Boundaries["removeUnavailability"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      unavailabilities: req.calendar.unavailabilities.filter(
        ({ uuid }) => unavailability.uuid !== uuid,
      ),
    },
  }));
}

export { handleUnavailabilityRemoval };
